export const initCopyrightYear = () => {
    const year = new Date().getFullYear();

    document.querySelectorAll('[data-copyright-year]').forEach((el) => {
        el.textContent = year;
    });
};
